import store from 'store'
import { getCurrentUserEmail } from 'user'

const getState = () => store.getState().application
const getApplicationEmail = (state = getState()) => i.getIn(state, [ 'data', 'email' ])

export function recordUser(str) {
  store.dispatch({ type: 'application/RECORD_WHO', data: str })
  if(getCurrentUserEmail() !== getApplicationEmail()) {
    store.dispatch({ type: 'application/CLEAR' })
  } else if(str === 'self') {
    store.dispatch({ type: 'application/CLEAR_OTHER' })
  }
}

export function readyForReview(app = store.getState().application.data) {
  // TODO
  return app && app.readyForReview
}

export function restoreState(state, { user }) {
  return user && user.email !== getApplicantEmailFromState() ? {} : state
}

export function submitApplication(data) {
  // TODO clear application data on success?
  return Promise.resolve(Object.assign({}, data, { state: 'active' })) // FAKE
}

export default function application(state = { data: {}, who: null }, { type, data }) {
  if(!getApplicationEmail(state)) {
    const currentUserEmail = typeof getCurrentUserEmail === 'function' ? getCurrentUserEmail() : null
    if(currentUserEmail) state = i.setIn(state, [ 'data', 'email' ], currentUserEmail)
  }
  if(type === 'application/RECORD_WHO') {
    return i.assign(state, { who: data })
  }
  if(type === 'application/PATCH') {
    return i.updateIn(state, [ 'data' ], (oldData) => ({ ...oldData, ...data, readyForReview: false }))
  }
  if(type === 'application/SET_ROLES') {
    return i.setIn(state, [ 'data', 'applicant', 'roles' ], data)
  }
  if(type === 'application/SET_READY_FOR_REVIEW') {
    return i.setIn(state, [ 'data', 'readyForReview' ], data)
  }
  if(type === 'application/CLEAR') {
    return i.assign(state, { data: {} })
  }
  if(type === 'application/CLEAR_OTHER') {
    return i.setIn(state, [ 'data', 'other' ], null)
  }
  return state
}
